import { apiSlice } from "../api/apiSlice";
import { loginUser } from "./authSlice";

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => ({
        url: "/login",
        method: "POST",
        body,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          localStorage.setItem(
            "auth",
            JSON.stringify({
              accessToken: result.data.accessToken,
              user: result.data.user,
            })
          );
          dispatch(
            loginUser({
              accessToken: result.data.accessToken,
              user: result.data.user,
            })
          );
        } catch (err) {}
      },
    }),
  }),
});

export const { useLoginMutation } = authApi;
